<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh
                            v-if="shipping_carrier.company_id && shipping_carrier.company_id > 0"
                            @invoke-method="dbGetShippingCarrier(true)"
                        ></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="shipping_carrier.company_id && shipping_carrier.company_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('shipping_carriers.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in shipping_carrier_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != shipping_carrier.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('shipping_carriers.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_shipping_carrier.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'shipping_carriers' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="shipping_carrier.status" class="ribbon ribbon-top-right" :class="`ribbon-${shipping_carrier.status_class}`">
                            <span class="ribbon-span">{{ shipping_carrier.status }}</span>
                        </div>
                        <v-form ref="formShippingCarrier">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="shipping_carrier_dialog"
                                    v-model="shipping_carrier.company_id"
                                    :label="$t('lang.company_id')"
                                    :counter="showCounter(shipping_carrier.company_id, 'shipping_carriers.company_id')"
                                    :rules="ifValid('shipping_carriers.company_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.parent_id"
                                    :label="$t('lang.parent_id')"
                                    :counter="showCounter(shipping_carrier.parent_id, 'shipping_carriers.parent_id')"
                                    :rules="ifValid('shipping_carriers.parent_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.stripe_id"
                                    :label="$t('lang.stripe_id')"
                                    :counter="showCounter(shipping_carrier.stripe_id, 'shipping_carriers.stripe_id')"
                                    :rules="ifValid('shipping_carriers.stripe_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.zoho_customer_id"
                                    :label="$t('lang.zoho_customer_id')"
                                    :counter="showCounter(shipping_carrier.zoho_customer_id, 'shipping_carriers.zoho_customer_id')"
                                    :rules="ifValid('shipping_carriers.zoho_customer_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.organisation_type_id"
                                    :label="$t('lang.organisation_type_id')"
                                    :counter="showCounter(shipping_carrier.organisation_type_id, 'shipping_carriers.organisation_type_id')"
                                    :rules="ifValid('shipping_carriers.organisation_type_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.company"
                                    :label="`${$t('lang.company')} *`"
                                    :counter="showCounter(shipping_carrier.company, 'shipping_carriers.company')"
                                    :rules="ifValid('shipping_carriers.company')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.company_short"
                                    :label="$t('lang.company_short')"
                                    :counter="showCounter(shipping_carrier.company_short, 'shipping_carriers.company_short')"
                                    :rules="ifValid('shipping_carriers.company_short')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.website"
                                    :label="$t('lang.website')"
                                    :counter="showCounter(shipping_carrier.website, 'shipping_carriers.website')"
                                    :rules="ifValid('shipping_carriers.website')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.correspondence_method"
                                    :label="$t('lang.correspondence_method')"
                                    :counter="showCounter(shipping_carrier.correspondence_method, 'shipping_carriers.correspondence_method')"
                                    :rules="ifValid('shipping_carriers.correspondence_method')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.currency_code"
                                    :label="`${$t('lang.currency_code')} *`"
                                    :counter="showCounter(shipping_carrier.currency_code, 'shipping_carriers.currency_code')"
                                    :rules="ifValid('shipping_carriers.currency_code')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.exchange_rate_id"
                                    :label="`${$t('lang.exchange_rate_id')} *`"
                                    :counter="showCounter(shipping_carrier.exchange_rate_id, 'shipping_carriers.exchange_rate_id')"
                                    :rules="ifValid('shipping_carriers.exchange_rate_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-autocomplete
                                    v-model="shipping_carrier.payment_term_id"
                                    :label="$t('lang.payment_term')"
                                    :items="payment_terms"
                                    item-value="payment_term_id"
                                    item-text="payment_term_id"
                                    :rules="ifValid('shipping_carriers.payment_term_id')"
                                ></bc-autocomplete>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.turn_around_days"
                                    :label="$t('lang.turn_around_days')"
                                    :counter="showCounter(shipping_carrier.turn_around_days, 'shipping_carriers.turn_around_days')"
                                    :rules="ifValid('shipping_carriers.turn_around_days')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="shipping_carrier.has_nda"
                                    :label="`${$t('lang.has_nda')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('shipping_carriers.has_nda')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="shipping_carrier.has_contract"
                                    :label="`${$t('lang.has_contract')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('shipping_carriers.has_contract')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.ship_label_type"
                                    :label="`${$t('lang.ship_label_type')} *`"
                                    :counter="showCounter(shipping_carrier.ship_label_type, 'shipping_carriers.ship_label_type')"
                                    :rules="ifValid('shipping_carriers.ship_label_type')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-textarea
                                    v-model="shipping_carrier.notes"
                                    :label="$t('lang.notes')"
                                    auto-grow
                                    rows="1"
                                    :rules="ifValid('shipping_carriers.notes')"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.logo_id"
                                    :label="$t('lang.logo_id')"
                                    :counter="showCounter(shipping_carrier.logo_id, 'shipping_carriers.logo_id')"
                                    :rules="ifValid('shipping_carriers.logo_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.packing_list_fields"
                                    :label="$t('lang.packing_list_fields')"
                                    :counter="showCounter(shipping_carrier.packing_list_fields, 'shipping_carriers.packing_list_fields')"
                                    :rules="ifValid('shipping_carriers.packing_list_fields')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="shipping_carrier.logo"
                                    :label="$t('lang.logo')"
                                    :counter="showCounter(shipping_carrier.logo, 'shipping_carriers.logo')"
                                    :rules="ifValid('shipping_carriers.logo')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="shipping_carrier.status"
                                    :label="`${$t('lang.status')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('shipping_carriers.status')"
                                ></bc-select>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'shipping_carriers' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="saveShippingCarriers">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_shipping_carrier"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_shipping_carrier')"
                :message="$t('lang.delete_shipping_carrier_confirm')"
                @onConfirm="deleteShippingCarriers()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_shipping_carrier_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeleteShippingCarrierDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            shipping_carrier: {},
            file_name: "",
            dbGetShippingCarrier: _.debounce(this.getShippingCarrier, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchShippingCarrier", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.shipping_carrier) {
                        this.shipping_carrier = this.assignObj2(data.shipping_carrier, this.rules_shipping_carriers);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=shipping_carrier_status&sort_by=2",
                            method: "get",
                            stateProperty: "shipping_carrier_status_options",
                            dataProperty: "options",
                            commit: true,
                        });
                        this.refresh();
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "shipping_carriers", replace: true });
                    }
                });
        } else {
            this.refresh();
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchShippingCarrier", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.shipping_carrier) {
                        next((vm) => {
                            vm.shipping_carrier = vm.assignObj2(data.shipping_carrier, vm.rules_shipping_carriers);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=shipping_carrier_status&sort_by=2",
                                method: "get",
                                stateProperty: "shipping_carrier_status_options",
                                dataProperty: "options",
                                commit: true,
                            });
                            vm.refresh();
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "shipping_carriers", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.refresh();
                vm.finishLoader();
            });
        }
    },
    computed: {
        ...mapState({
            rules_shipping_carriers: (state) => state.shipping_carriers.rules_shipping_carriers,
            shipping_carrier_status_options: (state) => state.settings.shipping_carrier_status_options,
            shipping_carriers: (state) => state.shipping_carriers.shipping_carriers,
            selectedShippingCarrier: (state) => state.shipping_carriers.selectedShippingCarrier,
            payment_terms: (state) => state.payment_terms.payment_term_options,
        }),
    },
    methods: {
        ...mapActions(["fetchShippingCarrier", "saveShippingCarrier", "deleteShippingCarrier", "printShippingCarrier", "fetchPaymentTerms"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getShippingCarrier(pg_refresh = false) {
            this.startLoader();

            this.fetchShippingCarrier({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.shipping_carrier) {
                    this.shipping_carrier = this.assignObj2(data.shipping_carrier, this.rules_shipping_carriers);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printShippingCarrier({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.shipping_carrier) {
                    if (this.dev_mode) {
                        this.file_name = data.shipping_carrier.file_name;
                    } else {
                        this.$refs.print.printReport(data.shipping_carrier.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        saveShippingCarriers() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formShippingCarrier")) {
                    let body = this.prepForm(this.shipping_carrier, this.rules_shipping_carriers);

                    this.saveShippingCarrier({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.shipping_carrier) {
                            this.$router.push({ name: "shipping_carrier", params: { id: data.shipping_carrier.company_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { company_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.saveShippingCarriers({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.shipping_carrier) {
                    this.shipping_carrier = this.assignObj2(data.shipping_carrier, this.rules_shipping_carriers);
                }
            });
        },
        deleteShippingCarriers() {
            this.deleteShippingCarrier({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "shipping_carriers" });
                }
                this.toggleModalLoader(false);
            });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchShippingCarrier({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.shipping_carrier) {
                        this.shipping_carrier = this.assignObj2(data.shipping_carrier, this.rules_shipping_carriers);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }

            if (this.payment_terms.length == 0 || force == true) await this.fetchPaymentTerms({ body: { options: 1 } });
        },
    },
    created() {},
};
</script>
